import i18n from 'i18next';
import { jwtDecode } from 'jwt-decode';
import OneSignal from 'react-onesignal';

// Wait for i18n to be initialized before setting up OneSignal
await i18n.loadNamespaces(''); // Load the default namespace

try {
  // @ts-expect-error OneSignal is not typed/exported correctly
  await OneSignal.init({
    appId: import.meta.env.VITE_ONESIGNAL_APP_ID,
    allowLocalhostAsSecureOrigin: true,
    welcomeNotification: {
      title: i18n.t('pushNotifications.welcome.title'),
      message: i18n.t('pushNotifications.welcome.message'),
      url: window.location.href,
    },
  });
} catch (err) {
  // OneSignal's domain check throws when running on a host the app isn't configured for
  // (e.g. localhost on a non-default port). Swallow so the admin still boots.
  console.warn('OneSignal init skipped:', (err as Error)?.message);
}

export const onesignalLogin = (token: string) => {
  const { id } = jwtDecode(token) as any;
  window.localStorage.setItem('atlas:token', token);
  // @ts-expect-error OneSignal is not typed/exported correctly
  void OneSignal.login(id);
};

// If already logged in when opening the app, login in OneSignal
// OneSignal.login() needs to be called after OneSignal.init() otherwise it will spit an error on the console
// TypeError: Cannot read properties of undefined (reading 'tt')
if (window.localStorage.getItem('atlas:token')) {
  onesignalLogin(window.localStorage.getItem('atlas:token') as string);
}
